// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

// Private
import Dashboard from "@/views/dashboard/index";
import Announcement from "@/views/announcements/index";
import AnnouncementIndex from "@/views/announcements/index";
import AnnouncementCreate from "@/views/announcements/create";
import AnnouncementEdit from "@/views/announcements/edit";
import AnnouncementShow from "@/views/announcements/show";

// Public
import Home from "@/views/home/index";
import Vehicle from "@/views/vehicles/index";
import Motorcycle from "@/views/motorcycles/index";
import Truck from "@/views/trucks/index";
import New from "@/views/news/index";
import Contact from "@/views/contact/index";

import Advertise from "@/views/advertises/index";
import AdvertiseState from "@/views/advertises/state";
import AdvertiseCity from "@/views/advertises/city";
import AdvertiseView from "@/views/advertises/view";

import Login from "@/views/auth/login";
import Register from "@/views/auth/register";
import NotFound from "@/views/notFound";
import NotAuthorized from "@/views/notAuthorized";

// Layout
import PublicLayout from "@/layouts/publicLayout";
import Maintenance from "@/views/maintenance.vue";

const isMaintenance = process.env.VUE_APP_MAINTENANCE_MODE === "true";

const routes = isMaintenance ? [
  {
    path: "/:catchAll(.*)",
    name: "Maintenance",
    component: Maintenance,
  },
] : [
  {
    path: "/",
    component: PublicLayout,
    children: [
      {
        path: "/",
        name: "home",
        component: Home,
        meta: { hideSearch: true }
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "/anunciar",
        name: "announcement-index",
        component: AnnouncementIndex,
      },
      {
        path: "/anunciar/create",
        name: "announcement-create",
        component: AnnouncementCreate,
      },
      {
        path: "/anunciar/:id/edit",
        name: "announcement-edit",
        component: AnnouncementEdit,
        props: true,
      },
      {
        path: "/anunciar/:id/show",
        name: "announcement-show",
        component: AnnouncementShow,
        props: true,
      },
      {
        path: "/vehicles",
        name: "vehicle",
        component: Vehicle,
      },
      {
        path: "/motorcycles",
        name: "motorcycle",
        component: Motorcycle,
      },
      {
        path: "/trucks",
        name: "truck",
        component: Truck,
      },
      {
        path: "/news",
        name: "new",
        component: New,
      },
      {
        path: "/contact",
        name: "contact",
        component: Contact,
      },
      {
        path: "/Announcement",
        name: "announcement",
        component: Announcement,
      },
      {
        path: "/advertise",
        name: "advertise",
        component: Advertise,
      },
      {
        path: "/login",
        name: "login",
        component: Login,
      },
      {
        path: "/register",
        name: "register",
        component: Register,
      },
      
      {
        path: "/401",
        name: "notAuthorized",
        component: NotAuthorized,
      },            
      {
        path: '/:state',
        name: "advertise-state",
        component: AdvertiseState,
        props: true
      },
      {
        path: '/:state/:city',
        name: "advertise-city",
        component: AdvertiseCity,
        props: true
      },
      {
        path: '/:state/:city/:id',
        name: "advertise-view",
        component: AdvertiseView,
        props: true,
      },
      { path: "/:pathMatch(.*)*", name: "notFound", component: NotFound },
    ],
    meta: {
      requireAuth: false,
    },
  },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.matched.some((x) => x.meta.requireAuth);
  const roles = to.meta.roles;

  // Verificar se o usuário está autenticado
  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: "login" });
    return;
  }

  // Verificação de papel (roles)
  if (roles) {
    const userRoles = authStore.user?.roles || [];
    const authorized = roles.some((role) => userRoles.includes(role));

    if (!authorized) {
      next({ name: "notAuthorized" });
      return;
    }
  }

  // Verificar a expiração do token
  const expiresAt = localStorage.getItem("expiresAt");
  if (expiresAt && new Date().getTime() > expiresAt) {
    authStore.logout(); // Realiza o logout
    next({ name: "login" }); // Redireciona para login
    return;
  }

  next(); // Continuar a navegação
});
export default router;
